export interface Option {
    value: string;
    label: string;
}

export const geneticDataOptions: Option[] = [
    {value: 'FASTQ', label: 'FASTQ'},
    {value: 'CRAM', label: 'CRAM'},
    {value: 'VCF', label: 'VCF'},
];

export const phenotypicDataOptions: Option[] = [
    {value: 'diagnosis', label: 'Diagnosis'},
    {value: 'procedures', label: 'Procedures'},
    // {value: 'medication', label: 'Medication'},
    // {value: 'lab', label: 'Lab'},
];

export interface CohortRule {
    type: string;
    value: string;
}